<template>
  <div ref="chart" style="width: 100%; height: 400px;"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'BarGraph',
  props: {
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      const options = {
        ...this.chartOptions
      };
      this.chart.setOption(options);
    },
  },
};
</script>

<style scoped>
/* Add any specific styles for the BarGraph component */
</style>
